import React from 'react';
import RoundCheckbox from './components/RoundCheckbox';
import RefundItemAccordion from './components/RefundItemAccordion';
import styles from "../../styles.module.scss";
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import {DISCRETIONARY_REFUND, WITHDRAWAL_REFUND } from '../../utils';
import SubTypeRefundDetailsForm from './components/SubTypeRefundDetailsForm';
import DownloadSupportingDoc from './components/DownloadSupportingDoc';

const DiscretionaryRefundItem = ({
    payableRefundInfo,
    selectedRefundItems,
    refundItemCheckboxHandler,
    refundDetailsForm,
    handleRefundDetailsForm,
    isConcessionRefund,
    isFullRefund,
    refundReasons,
    viewOnly,
    isLoanCase,
    setLoading,
    forRefundEdit
}) => {

    const isWithdrawalRefund = selectedRefundItems?.includes(WITHDRAWAL_REFUND);
    const isDisabled = (isConcessionRefund || isFullRefund || isWithdrawalRefund);
    const { totalRefundableAmount } = payableRefundInfo?.[DISCRETIONARY_REFUND] ?? {};
    const isSelected = selectedRefundItems?.includes(DISCRETIONARY_REFUND);

    const enableItemSelection = !viewOnly && !forRefundEdit;
    const {payableToParent, payableToVendor} = refundDetailsForm?.[DISCRETIONARY_REFUND];
    const discretionaryRefundAmount = Number(payableToParent) + Number(payableToVendor);

    return (
        <RefundItemAccordion
            isDisabled={isDisabled}
        >
            <div className='d-flex align-items-center'>

                {
                    enableItemSelection &&
                    <RoundCheckbox
                        isChecked={isSelected}
                        onChange={(checked) => refundItemCheckboxHandler(DISCRETIONARY_REFUND, checked)}
                        isDisabled={isDisabled}
                    />
                }

                <div className={`${styles['accordion-title']} mr-1`}>Discretionary •</div>

                <div className={`${styles['amount']}`}>{formattedPrice(discretionaryRefundAmount)}</div>
                <div className='d-flex ml-auto'>
                    <DownloadSupportingDoc
                        isDisabled={isDisabled}
                        isSelected={isSelected}
                        refundDetailsForm={refundDetailsForm}
                        refundSubType={DISCRETIONARY_REFUND}
                        isLoanCase={isLoanCase}
                        setLoading={setLoading}
                    />
                    
                </div>
            </div>


            <SubTypeRefundDetailsForm
                refundItemName={DISCRETIONARY_REFUND}
                form={refundDetailsForm}
                formHandler={handleRefundDetailsForm}
                amountFieldRequired
                isDisabled={(isDisabled || !isSelected || viewOnly)}
                // reasonInputType='input'
                reasonsDropdownData={refundReasons?.[DISCRETIONARY_REFUND]}
                maxRefundAmount={totalRefundableAmount}
                isLoanCase={isLoanCase}
            />

        </RefundItemAccordion>

    );
}

export default DiscretionaryRefundItem;